module.exports = __webpack_public_path__ + "img/iStock-853580922.55dcf0b6.jpg";